import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbsComponent } from './base-components/breadcrumbs/breadcrumbs.component';
import { FooterComponent } from './base-components/footer/footer.component';
import { HeaderComponent } from './base-components/header/header.component';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './base-components/sidebar/sidebar.component';
import { AuthGuard } from './guard/auth-guard.service';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';

@NgModule({
  declarations: [
    BreadcrumbsComponent,
    FooterComponent,
    HeaderComponent,
    SidebarComponent,
  ],
  imports: [CommonModule, RouterModule, AvatarModule, AvatarGroupModule],
  providers: [AuthGuard],
  exports: [
    BreadcrumbsComponent,
    FooterComponent,
    HeaderComponent,
    SidebarComponent,
  ],
})
export class CoreModule {}
